import {vw_store_inventory} from 'openapi'

export interface ProductProps {
  show?: boolean
  product?: vw_store_inventory
}

const initState: ProductProps = {
  show: false,
  product: {},
}

export const types = {
  CLEAR_SELECTED_PRODUCT: 'CLEAR_SELECTED_PRODUCT',
  SELECT_PRODUCT: 'SELECT_PRODUCT',
  SHOW_MODAL: 'SHOW_MODAL',
}

export const productModalActions = {
  selectProduct: (obj: any) => ({type: types.SELECT_PRODUCT, obj}),
  clearSelectedProduct: () => ({type: types.CLEAR_SELECTED_PRODUCT}),
  showModal: (value: boolean) => ({type: types.SHOW_MODAL, value}),
}

const productReducer = (state = initState, action: any) => {
  switch (action.type) {
    case types.SHOW_MODAL:
      return {
        ...state,
        show: action.value,
      }
    case types.SELECT_PRODUCT:
      return {
        ...state,
        product: action.obj,
      }
    case types.CLEAR_SELECTED_PRODUCT:
      return {
        ...state,
        show: false,
        product: null,
      }
    default:
      return {...state}
  }
}

export {productReducer}
